(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-detail-slider"] && !Shopify.designMode) return;
  try {
    
  class ProductSlider extends HTMLElement {
    connectedCallback() {
      this.prevBtn = this.closest('.product-detail-slider')?.querySelector('[data-direction="prev"]');
      this.nextBtn = this.closest('.product-detail-slider')?.querySelector('[data-direction="next"]');

      this.prevBtn?.addEventListener('click', () => this.#scroll('prev'));
      this.nextBtn?.addEventListener('click', () => this.#scroll('next'));
      this.addEventListener('scroll', this.#updateArrows.bind(this), { passive: true });

      this.#updateArrows();
    }

    #scroll(direction) {
      const slide = this.querySelector('.product-detail-slider__slide');
      if (!slide) return;

      const gap = parseFloat(getComputedStyle(this).gap) || 0;
      const distance = slide.offsetWidth + gap;

      this.scrollBy({
        left: direction === 'next' ? distance : -distance,
        behavior: 'smooth',
      });
    }

    #updateArrows() {
      if (!this.prevBtn || !this.nextBtn) return;

      const tolerance = 2;
      this.prevBtn.disabled = this.scrollLeft <= tolerance;
      this.nextBtn.disabled = this.scrollLeft + this.clientWidth >= this.scrollWidth - tolerance;
    }
  }

  if (!customElements.get('product-slider')) {
    customElements.define('product-slider', ProductSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
